import React, { Component } from 'react';
import Project from './Project';
import {
  heartroutine,
  johnnyMinn,
  polyfill,
  kalimpong,
  bookreport,
  dolphin,
  culturebook,
  tugboat,
  good,
  mso,
  spacebook,
} from './lib/projects';
import './MyWork.css';

export default class MyWork extends Component {
  projects = [
    heartroutine,
    johnnyMinn,
    polyfill,
    kalimpong,
    bookreport,
    dolphin,
    culturebook,
    tugboat,
    good,
    mso,
    // dbvmapper,
    spacebook,
  ];

  render() {
    return (
      <section id="my-work" className="work">
        <div className="projects">
          {this.projects.map((project, i) => <Project key={i} project={project} />)}
        </div>
      </section>
    );
  }
}
